import React, { useEffect, useRef, useState } from 'react';

function dataUrlEnBlob(dataUrl) {
  const raw = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl;
  const bin = atob(raw);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
}

/** Rend un .docx dans une modale via docx-preview (import lazy).
 *  Props : dataUrl (data:…;base64,…), filename, onClose. */
const DocxViewerModal = ({ dataUrl, filename = 'document.docx', onClose }) => {
  const ref = useRef(null);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState(null);

  useEffect(() => {
    let annule = false;
    (async () => {
      try {
        const { renderAsync } = await import('docx-preview');
        if (annule || !ref.current) return;
        ref.current.innerHTML = '';
        await renderAsync(dataUrlEnBlob(dataUrl), ref.current, undefined, {
          inWrapper: true, ignoreWidth: false, breakPages: true,
        });
        if (!annule) setChargement(false);
      } catch (e) {
        if (!annule) { setErreur(e?.message || 'Rendu du document impossible'); setChargement(false); }
      }
    })();
    return () => { annule = true; };
  }, [dataUrl]);

  const telecharger = () => {
    const a = document.createElement('a');
    a.href = dataUrl; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
  };

  const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 1000010, display: 'flex', flexDirection: 'column' };
  const header = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.6rem 1rem', background: '#1f2937', color: 'white', flex: '0 0 auto' };
  const body = { flex: '1 1 auto', overflowY: 'auto', padding: '24px', background: '#374151' };
  const btn = { background: 'none', border: '1px solid rgba(255,255,255,0.5)', color: 'white', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: '0.85rem' };

  return (
    <div style={overlay} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={header}>
        <span style={{ fontSize: '0.9rem', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📄 {filename}</span>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={btn} onClick={telecharger}>⬇︎ Télécharger l'original</button>
          <button style={btn} onClick={onClose}>✕ Fermer</button>
        </div>
      </div>
      <div style={body}>
        {chargement && <p style={{ color: 'white', textAlign: 'center' }}>Rendu du document…</p>}
        {erreur && <p style={{ color: '#fca5a5', textAlign: 'center' }}>Impossible d'afficher : {erreur}. Utilisez « Télécharger l'original ».</p>}
        <div ref={ref} style={{ maxWidth: 900, margin: '0 auto', background: 'white', borderRadius: 8 }} />
      </div>
    </div>
  );
};

export default DocxViewerModal;
